import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';
import './TesteIA.css';

export default function TesteIAAnalises() {
  const navigate = useNavigate();
  const [analises, setAnalises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({ titulo: '', resumo: '', runs_ids: '', conteudo_markdown: '' });
  const [saving, setSaving] = useState(false);

  const carregar = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/ai-testes/analises`);
      setAnalises(data);
    } catch (err) {
      console.error('Erro ao listar análises:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const submeter = async () => {
    if (!form.titulo.trim() || !form.conteudo_markdown.trim()) {
      alert('Título e conteúdo são obrigatórios');
      return;
    }
    setSaving(true);
    try {
      const runsArr = form.runs_ids
        .split(/[,\s]+/).filter(Boolean).map(Number).filter(Number.isInteger);
      const { data } = await axios.post(`${API_URL}/api/ai-testes/analises`, {
        titulo: form.titulo,
        resumo: form.resumo,
        runs_ids: runsArr,
        conteudo_markdown: form.conteudo_markdown,
      });
      setModalOpen(false);
      setForm({ titulo: '', resumo: '', runs_ids: '', conteudo_markdown: '' });
      navigate(`/teste-ia/analises/${data.id}`);
    } catch (err) {
      alert('Erro: ' + (err.response?.data?.error || err.message));
    } finally {
      setSaving(false);
    }
  };

  const remover = async (id) => {
    if (!window.confirm(`Remover análise #${id}?`)) return;
    try {
      await axios.delete(`${API_URL}/api/ai-testes/analises/${id}`);
      carregar();
    } catch (err) {
      alert('Erro: ' + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className="data-page">
      <div className="page-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <div>
          <button className="btn-link" onClick={() => navigate('/teste-ia')}>← Voltar pra runs</button>
          <h1 style={{ margin: '8px 0 4px 0' }}>📑 Análises Consolidadas</h1>
          <small style={{ color: '#666' }}>Relatórios markdown vinculados a um ou mais runs de teste IA.</small>
        </div>
        <button className="btn-primary" onClick={() => setModalOpen(true)}>+ Nova análise</button>
      </div>

      {loading ? <p>Carregando...</p> : (
        <table className="data-table" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th style={{ width: 50 }}>#</th>
              <th>Título</th>
              <th>Resumo</th>
              <th style={{ width: 110 }}>Runs</th>
              <th style={{ width: 80 }}>Tamanho</th>
              <th style={{ width: 150 }}>Criado em</th>
              <th style={{ width: 100 }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {analises.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 30, color: '#888' }}>
                Nenhuma análise salva ainda.
              </td></tr>
            ) : analises.map(a => (
              <tr key={a.id} style={{ cursor: 'pointer' }}>
                <td>{a.id}</td>
                <td onClick={() => navigate(`/teste-ia/analises/${a.id}`)}>
                  <strong>{a.titulo}</strong>
                </td>
                <td onClick={() => navigate(`/teste-ia/analises/${a.id}`)}>
                  <small style={{ color: '#666' }}>{a.resumo || '-'}</small>
                </td>
                <td>{(a.runs_ids || []).map(r => `#${r}`).join(', ') || '-'}</td>
                <td><small>{a.tamanho ? `${(a.tamanho/1024).toFixed(1)}KB` : '-'}</small></td>
                <td><small>{new Date(a.created_at).toLocaleString('pt-BR')}</small></td>
                <td>
                  <button className="btn-link" onClick={() => navigate(`/teste-ia/analises/${a.id}`)}>Ver</button>
                  {' · '}
                  <button className="btn-link" style={{ color: '#c62828' }} onClick={() => remover(a.id)}>×</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {modalOpen && (
        <div className="modal-backdrop" onClick={() => setModalOpen(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 720 }}>
            <h2>Nova análise consolidada</h2>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>Título *</label>
              <input
                type="text" value={form.titulo}
                onChange={e => setForm(f => ({ ...f, titulo: e.target.value }))}
                placeholder="ex: Consolidado runs 3-5 (8 modelos)"
                style={{ width: '100%', padding: 8, border: '1px solid #ccc', borderRadius: 4 }}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>Resumo curto (1 linha)</label>
              <input
                type="text" value={form.resumo}
                onChange={e => setForm(f => ({ ...f, resumo: e.target.value }))}
                placeholder="ex: Qwen3.6 lidera; MiniMax melhor custo-benefício"
                style={{ width: '100%', padding: 8, border: '1px solid #ccc', borderRadius: 4 }}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>IDs dos runs (separados por vírgula)</label>
              <input
                type="text" value={form.runs_ids}
                onChange={e => setForm(f => ({ ...f, runs_ids: e.target.value }))}
                placeholder="ex: 3, 4, 5"
                style={{ width: '100%', padding: 8, border: '1px solid #ccc', borderRadius: 4 }}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>Conteúdo (Markdown) *</label>
              <textarea
                value={form.conteudo_markdown}
                onChange={e => setForm(f => ({ ...f, conteudo_markdown: e.target.value }))}
                placeholder="# Título&#10;&#10;Use markdown — tabelas, listas, negrito **assim**, etc."
                rows={14}
                style={{ width: '100%', padding: 8, border: '1px solid #ccc', borderRadius: 4, fontFamily: 'monospace', fontSize: 13 }}
              />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn-secondary" onClick={() => setModalOpen(false)} disabled={saving}>Cancelar</button>
              <button className="btn-primary" onClick={submeter} disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
